var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcici(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_4172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.19128 5.21314C12.6716 -0.226914 19.3201 -1.63879 21.9808 2.06915C24.6414 5.77709 22.303 13.2715 16.8227 18.7116C11.3423 24.1919 4.69382 25.6018 1.99293 21.8535C-0.625388 18.1073 1.71297 10.6512 7.19128 5.21314Z",
    fill: "#F06321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8187 2.31081C10.2145 2.75391 9.61024 3.27757 9.00602 3.84353C4.21047 8.59678 2.19435 15.1244 4.573 18.3893C7.03018 21.6521 12.9133 20.4437 17.8297 15.6481C20.4903 13.0701 22.2627 10.0872 22.9878 7.30777C23.1892 5.2534 22.9073 3.4387 21.9808 2.06912C19.8861 -0.831168 15.3726 -0.591493 10.8187 2.31081Z",
    fill: "#AE282E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7491 2.91502V3.03587C17.7089 3.72066 17.306 4.56657 16.5809 5.29165C15.4933 6.33897 14.0432 6.74179 13.4369 6.13958C12.7521 5.49507 13.157 4.0832 14.2446 2.95531C15.3725 1.8677 16.8226 1.50516 17.4268 2.14967C17.6282 2.35108 17.7491 2.59277 17.7491 2.91502ZM13.5598 21.4104C10.9797 23.3439 8.32113 24.3127 5.74109 23.9099C6.8287 23.9502 7.7169 22.7397 8.44197 21.1284C9.16705 19.4769 9.56986 17.9462 9.93239 16.494C10.4561 14.198 10.4964 12.5867 10.2144 12.2241C9.77127 11.6582 8.8045 11.781 7.6746 12.4256C7.11066 12.7478 6.38559 12.5464 7.23352 11.4991C8.11972 10.4517 11.5437 7.95226 12.7521 7.54944C14.1237 7.1869 15.6544 7.71057 15.1308 9.201C14.7662 10.2886 10.013 22.6994 13.5598 21.4104Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_4172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcici);
export default __webpack_public_path__ + "static/media/ICICI.3912b1e46ae1119084b592e0a587ea63.svg";
export { ForwardRef as ReactComponent };